import {Props} from './types';

import utils from '@utils';
import constants from '@constants';
import paths from '@paths';

export const getLabel = (me: MeStore, option: Props['option']) => {
  let text = '';

  if (me.plan === option) {
    text = '契約中のプラン';
  }
  if (me.plan !== option) {
    text = 'プランを変更する';
  }

  return text;
};

export const goConfirm = async (
  me: MeStore,
  option: number,
  history: any,
  setLoading: any,
  setIsModal: any
) => {
  setLoading(true);
  try {
    if (option === constants.PLAN.FREE) {
      // 無料プランを押下した時
      // TODO 無料プランに戻って機能が削減されるモーダルを表示
      // TODO プランのダウングレードができるかバリデーションする
      history.push({
        pathname: paths.options.confirm,
        state: {
          plan: option,
        },
      });
    } else if (option === constants.PLAN.SAFETY) {
      // スタンダードプランを押下した場合
      const hasCard = await utils.stripe.hasCard(me.customerId);

      if (hasCard) {
        history.push({
          pathname: paths.options.confirm,
          state: {
            plan: option,
          },
        });
      } else {
        //  もしカード情報が無ければ、モーダルを開いてカード情報を登録させる
        setIsModal(true);
      }
    } else if (option === constants.PLAN.SAFETY_X) {
      // エンタープライズプランを押下した場合
      history.push({
        pathname: paths.options.main,
        state: {
          plan: option,
        },
      });
    }
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};
